import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { isMChatEnabled } from 'owa-copilot-settings-utils';

export function isCommercialBizChatAvailable(mailboxInfo?: MailboxInfo): boolean {
    return (
        !!isMChatEnabled(mailboxInfo ?? getGlobalSettingsAccountMailboxInfo()) &&
        !isConsumer(undefined, mailboxInfo)
    );
}
